// import React, { useState } from "react";
// import { Edit as EditIcon } from "@mui/icons-material";
// import {
//   Table as MuiTable,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TableSortLabel,
// } from "@mui/material";
// import { styled } from "@mui/system";

// // Custom styled components
// const CustomTableCell = styled(TableCell)({
//   backgroundColor: "#424752",
//   fontSize: "13px",
//   textAlign: "center",
//   color: "white",
//   border: "0px solid #e0e0e0",
//   cursor: "pointer",
//   padding: "8px",
//   width: "auto",
//   whiteSpace: "nowrap",
//   "&:hover": {
//     backgroundColor: "#2a2f3b",
//     color: "white",
//   },
//   "& .MuiTableSortLabel-root": {
//     color: "white",
//     "&:hover": {
//       color: "white",
//     },
//     "&.Mui-active": {
//       color: "white",
//     },
//   },
// });

// // Apply alternating row colors
// const CustomTableRow = styled(TableRow)(({ index, highlight }) => ({
//   backgroundColor: highlight
//     ? "#FFDDDD"
//     : index % 2 === 0
//     ? "#FFFFFF"
//     : "#F7F7F7",
// }));

// const BodyTableCell = styled(TableCell)({
//   border: "0px solid #e0e0e0",
//   padding: "8px",
//   textAlign: "center",
//   fontSize: "12px",
//   width: "auto",
//   whiteSpace: "nowrap",
// });

// const StatusTableCell = styled(BodyTableCell)(({ status }) => ({
//   color:
//     status === "Completed"
//       ? "green"
//       : status === "In Progress"
//       ? "orange"
//       : "black",
// }));

// const Table = ({
//   tableHeaders = [],
//   tableData = [],
//   initialOrder = "asc",
//   initialOrderBy = "",
//   handleEditClick,
//   rowHighlightCondition,
// }) => {
//   const [order, setOrder] = useState(initialOrder);
//   const [orderBy, setOrderBy] = useState(initialOrderBy);

//   const handleSort = (column) => {
//     const isAsc = orderBy === column && order === "asc";
//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(column);

//     // Sort the table data
//     tableData.sort((a, b) => {
//       if (a[column] < b[column]) {
//         return isAsc ? -1 : 1;
//       }
//       if (a[column] > b[column]) {
//         return isAsc ? 1 : -1;
//       }
//       return 0;
//     });
//   };

//   return (
//     <div className="my-5 overflow-auto">
//       <TableContainer component={Paper}>
//         <MuiTable>
//           <TableHead>
//             <TableRow>
//               {Array.isArray(tableHeaders) && tableHeaders.length > 0 ? (
//                 tableHeaders.map((header) => (
//                   <CustomTableCell
//                     key={header.dbParam}
//                     onClick={() => handleSort(header.dbParam)}
//                   >
//                     <TableSortLabel
//                       active={orderBy === header.dbParam}
//                       direction={orderBy === header.dbParam ? order : "asc"}
//                     >
//                       {header.displayName}
//                     </TableSortLabel>
//                   </CustomTableCell>
//                 ))
//               ) : (
//                 <CustomTableCell>No Headers Available</CustomTableCell>
//               )}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {Array.isArray(tableData) && tableData.length > 0 ? (
//               tableData.map((row, index) => (
//                 <CustomTableRow
//                   key={index}
//                   index={index}
//                   highlight={rowHighlightCondition && rowHighlightCondition(row)}
//                 >
//                   {tableHeaders.map((header) => (
//                     <React.Fragment key={header.dbParam}>
//                       {header.dbParam === "status_s" ? (
//                         <StatusTableCell status={row[header.dbParam]}>
//                           {row[header.dbParam]}
//                         </StatusTableCell>
//                       ) : header.dbParam === "edit" ? (
//                         <BodyTableCell>
//                           <EditIcon
//                             onClick={() => handleEditClick(row)}
//                             style={{ cursor: "pointer", fontSize: "18px" }}
//                           />
//                         </BodyTableCell>
//                       ) : (
//                         <BodyTableCell>{row[header.dbParam]}</BodyTableCell>
//                       )}
//                     </React.Fragment>
//                   ))}
//                 </CustomTableRow>
//               ))
//             ) : (
//               <TableRow>
//                 <TableCell colSpan={tableHeaders.length} align="center">
//                   No records found.
//                 </TableCell>
//               </TableRow>
//             )}
//           </TableBody>
//         </MuiTable>
//       </TableContainer>
//     </div>
//   );
// };

// export default Table;

import React from "react";
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
} from "@mui/material";
import { styled } from "@mui/system";

const CustomTableCell = styled(TableCell)({
  backgroundColor: "#424752",
  fontSize: "13px",
  textAlign: "center",
  color: "white",
  border: "0px solid #e0e0e0",
  cursor: "pointer",
  padding: "8px",
  width: "auto",
  whiteSpace: "nowrap",
  "&:hover": {
    backgroundColor: "#2a2f3b",
    color: "white",
  },
  "& .MuiTableSortLabel-root": {
    color: "white",
    "&:hover": {
      color: "white",
    },
    "&.Mui-active": {
      color: "white",
    },
  },
});

const CustomTableRow = styled(TableRow)(({ index, highlight }) => ({
  backgroundColor: highlight ? "#ffcccc" : index % 2 === 0 ? "#FFFFFF" : "#F7F7F7",
}));

const BodyTableCell = styled(TableCell)({
  border: "0px solid #e0e0e0",
  padding: "8px",
  textAlign: "center",
  fontSize: "12px",
  width: "auto",
  whiteSpace: "nowrap",
});

const StatusTableCell = styled(BodyTableCell)(({ status }) => ({
  color: status === "Completed" ? "green" : status === "In Progress" ? "orange" : "black",
}));

const Table = ({
  tableHeaders = [],
  tableData = [],
  order,
  orderBy,
  handleSort,
  rowHighlightCondition,
  highlightStyle,
  renderCell,               
}) => {
  return (
    <div className="my-5 overflow-auto">
      <TableContainer component={Paper}>
        <MuiTable>
          <TableHead>
            <TableRow>
              {Array.isArray(tableHeaders) && tableHeaders.length > 0 ? (
                tableHeaders.map((header) => (
                  <CustomTableCell
                    key={header.dbParam}
                    onClick={() => handleSort && handleSort(header.dbParam)}
                  >
                    <TableSortLabel
                      active={orderBy === header.dbParam}
                      direction={orderBy === header.dbParam ? order : "asc"}
                    >
                      {header.displayName}
                    </TableSortLabel>
                  </CustomTableCell>
                ))
              ) : (
                <CustomTableCell>No Headers Available</CustomTableCell>
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {Array.isArray(tableData) && tableData.length > 0 ? (
              tableData.map((row, index) => (
                <CustomTableRow
                  key={index}
                  index={index}
                  highlight={rowHighlightCondition && rowHighlightCondition(row)}
                >
                  {tableHeaders.map((header) => {
                    if (typeof renderCell === "function") {
                      const custom = renderCell(header, row);
                      if (custom !== null && custom !== undefined) {
                        return (
                          <BodyTableCell key={header.dbParam}>
                            {custom}
                          </BodyTableCell>
                        );
                      }
                    }
                    return (
                      <React.Fragment key={header.dbParam}>
                        {header.dbParam === "status" ? (
                          <StatusTableCell status={row[header.dbParam]}>
                            {row[header.dbParam]}
                          </StatusTableCell>
                        ) : (
                          <BodyTableCell>{row[header.dbParam]}</BodyTableCell>
                        )}
                      </React.Fragment>
                    );
                  })}
                </CustomTableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableHeaders.length} align="center">
                  No records found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </div>
  );
};

export default Table;